import { Injectable } from '@angular/core';
import { Auth, signOut, user, User } from '@angular/fire/auth';
import { IUsuario, Usuario } from '../../models/usuario.model';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from '../spinner/spinner.service';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { IServerResponse, ServerResponse } from '../../models/server-response.model';
import { ToastService } from '../toast/toast.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public loggedIn: boolean = false;
  public loadingAppUser: boolean = false;

  public currentFirebaseUser?: User;

  public currentUser?: Usuario;
  public subCurrentUser: Subject<Usuario> = new Subject<Usuario>();

  constructor(
    public auth: Auth,
    private http: HttpClient,
    private spinnerService: SpinnerService,
    private router: Router,
    public toastService: ToastService
  ) {

    user(this.auth).subscribe((_user: any) => {
      if (_user) {
        console.log('Existe usuario');

        this.loggedIn = true;
        this.currentFirebaseUser = _user;

        if (!this.currentUser && !this.loadingAppUser) {

          this.getUser();
        }

      } else {
        console.log('NO Existe usuario');
        this.loggedIn = false;
      }
    });

  }

  /* -------------------------------------------------------------------------- */
  /*                           ANCHOR getFirebaseUser                           */
  /* -------------------------------------------------------------------------- */
  // region getFirebaseUser
  async getFirebaseUser(): Promise<User | null> {
    return new Promise((resolve, reject) => {

      if (this.currentFirebaseUser) {
        resolve(this.currentFirebaseUser);
      } else {
        user(this.auth).subscribe((_user: any) => {
          if (_user) {
            console.log('Existe usuario');

            this.loggedIn = true;
            this.currentFirebaseUser = _user;
            // this.getUser();
            resolve(_user);
          } else {
            console.log('NO Existe usuario');
            this.loggedIn = false;
            resolve(null);
          }
        });
      }

    });

  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR getToken                              */
  /* -------------------------------------------------------------------------- */
  // region getToken
  async getToken(): Promise<string> {
    const user = await this.getFirebaseUser();

    const token = await user?.getIdToken();

    return token ?? '';
  }

  async signOut() {
    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cerrando sesión';

    await signOut(this.auth);

    this.currentUser = undefined;

    this.spinnerService.loading = false;
    this.spinnerService.message = '';

    sessionStorage.removeItem('user');
    this.loggedIn = false;
    sessionStorage.clear();
    this.router.navigate(['login']);
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR getUser                               */
  /* -------------------------------------------------------------------------- */
  // region getUser
  async getUser() {
    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cargando datos de usuario';

    this.loadingAppUser = true;

    const token = await this.currentFirebaseUser?.getIdToken();
    // console.log('token: ', token);

    const urlApi = `${environment.urlApi}/auth`;

    try {

      const response = await new Promise<ServerResponse<{ usuario: IUsuario }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ usuario: IUsuario }>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token ?? ''
              }
            }
          ).subscribe({
            next: (
              response: IServerResponse<{ usuario: IUsuario }>
            ) => resolve(
              new ServerResponse<{ usuario: IUsuario }>(response)
            ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response.data);

      if (response.statusCode === 200) {
        this.currentUser = new Usuario(
          response.data?.usuario!
        );

        this.subCurrentUser.next(this.currentUser);
      }

      console.log('this.currentUser => ',
        this.currentUser,
      );


    } catch (error) {
      console.log(error);
    }

    this.loadingAppUser = false;
    this.spinnerService.loading = false;
    this.spinnerService.message = '';
  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR signUp                               */
  /* -------------------------------------------------------------------------- */
  // region signUp
  async signUp(
    usuario: any
  ): Promise<boolean> {

    let flag = false;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Registrando usuario';

    const urlApi = `${environment.urlApi}/auth/sign-up`;

    try {
      const token = await this.getToken();

      const response = await new Promise<ServerResponse>(
        (resolve, reject) => {
          this.http.post<IServerResponse>(
            urlApi,
            usuario,
            {
              headers: {
                'content-type': 'application/json',
                'Authorization': token.toString()
              }
            }
          ).subscribe({
            next: (response: IServerResponse) => resolve(
              new ServerResponse(response)
            ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                this.toastService.show({
                  header: 'Error de servidor',
                  body: `${error}`,
                  classname: 'bg-danger text-white'
                });
                reject(error);
              }
            },
          });
        }
      );

      if (response.statusCode === 201) {
        flag = true;
      } else {
        this.toastService.show({
          header: 'Error de servidor',
          body: `${response.message}`,
          classname: 'bg-danger text-white'
        });
      }

    } catch (error) {
      console.log(error);
      this.toastService.show({
        header: 'Error',
        body: `${error}`,
        classname: 'bg-danger text-white'
      });
    }

    return flag;

  }

}
